export const ProfileSettingFeatureToggles = {
    securityTab: false,
    specialistTab: false,

    publicLink: false,
    publicProfile: false,
    connections: false,
    actionsButtons: false,
    donation: true
};